import {
  Box,
  Stack,
  Heading,
  Text,
  TextLink,
  Button,
  useDialogController
} from '@machobear/design-system'
import { useHistory } from 'react-router-dom'
import { Trans, useTranslation } from 'react-i18next'

import { Userpilot } from 'userpilot'
import { EquifaxLogo } from '@/components/icons'
import { breakpoints } from '@/styles'
import useMediaQuery from '@/hooks/use-media-query'

import useCurrentSession from '@/hooks/use-current-session'
import NoBillingUserDialog from '@/features/SponsoredListing/modals/no-billing-user-modal'
import StandaloneTrustScoreImage from '../images/standalonetrustscore.svg'

const TrustScoreTopper = () => {
  const tabletLandscape = useMediaQuery(`(max-width: ${breakpoints.tabletLandscape})`)
  const { t } = useTranslation()
  const session = useCurrentSession()
  const history = useHistory()
  const { visible, showModal, closeModal } = useDialogController()
  const handleStartScreening = () => {
    const isBillingUserValid = session?.billing_user_valid
    if (isBillingUserValid) {
      Userpilot.track(': app_standalone_ts_startscreen_btn')
      history.push(`/trust-score/credit-check`)
    } else {
      showModal()
    }
  }
  return (
    <>
      <NoBillingUserDialog open={visible} onClose={closeModal} />
      <Box
        display="flex"
        flexDirection="row"
        gap={{ mobile: 'large', tablet: 'large' }}
        justifyContent={{ desktop: 'spaceBetween' }}
        alignItems="center"
        marginX={{ mobile: 'small', tablet: 'xlarge', desktop: 'xlarge' }}
        marginTop="xlarge"
      >
        <Box display="flex" flexDirection="column" gap="large" style={{ width: '600px' }}>
          <Stack space="gutter">
            <Box display="flex" flexDirection="row" gap="small" alignItems="center">
              <Heading level="4">
                {t('l.standalone_trustscore.list.topper.trust_score.heading', 'Trust Score')}
              </Heading>
              <Box display="flex" flexDirection="row" alignItems="center" gap="xsmall">
                <Text size="small" tone="tertiary">
                  {t('l.standalone_trustscore.list.topper.powered_by.text', 'Powered by')}{' '}
                </Text>
                <EquifaxLogo width="70px" height="auto" style={{ marginTop: '4px' }} />
              </Box>
            </Box>
            <Trans i18nKey={'l.standalone_trustscore.list.topper.applicant_details'} t={t}>
              <Text>
                Enter applicant details to generate a{' '}
                <TextLink href="https://landlords.liv.rent/screening" target="_blank">
                  Trust Score
                </TextLink>{' '}
                report. Each report features an Equifax® credit summary, court records, risk
                assessment, and more.
              </Text>
            </Trans>
          </Stack>
          <Box style={{ width: '163px' }}>
            <Button onClick={handleStartScreening}>
              {t('l.standalone_trustscore.list.start_screening.text', 'Start Screening')}
            </Button>
          </Box>
        </Box>
        <Box component="a" href="https://landlords.liv.rent/screening" target="_blank">
          <Box
            component="img"
            src={StandaloneTrustScoreImage}
            style={{
              width: tabletLandscape ? '310px' : '400px',
              height: 'auto',
              objectFit: 'cover',
              objectPosition: '50% 50%'
            }}
          />
        </Box>
      </Box>
    </>
  )
}

export default TrustScoreTopper
